import * as styles from "./updateDisplayManager.module.scss";
export class UpdateDisplayManager {
    getHeaderClass() {
        return styles["update-display"];
    }
    shouldDisplayPortLabels() {
        return true;
    }
    getHeaderText(nodeData) {
        return nodeData.data.name;
    }
    getBackgroundColor() {
        return "";
    }
    updatePreviewContent(nodeData, contentArea) { }
}
//# sourceMappingURL=updateDisplayManager.js.map